import { create } from 'zustand';

export interface FormDraft {
  data: Record<string, any>; // Form field values
  timestamp: number; // When last saved
  isDirty: boolean; // Has unsaved changes
}

export interface FormDraftsState {
  drafts: Record<string, FormDraft>; // Key is formId
  // ── Keyed panel collapse state ────────────────────────────────────────
  collapsedPanels: Record<string, boolean>;
  setIsCollapsed: (panelId: string, collapsed: boolean) => void;

  saveDraft: (formId: string, data: Record<string, any>) => void;
  getDraft: (formId: string) => FormDraft | null;
  clearDraft: (formId: string) => void;
  getAllDrafts: () => Record<string, FormDraft>;
  getDraftCount: () => number;
}

export const useFormStore = create<FormDraftsState>()((set, get) => ({
  drafts: {},

  // ── Keyed collapse ────────────────────────────────────────────────────
  collapsedPanels: {},
  setIsCollapsed: (panelId, collapsed) =>
    set((s) => ({
      collapsedPanels: { ...s.collapsedPanels, [panelId]: collapsed },
    })),
  saveDraft: (formId, data) => {
    set((state) => ({
      drafts: {
        ...state.drafts,
        [formId]: {
          data,
          timestamp: Date.now(),
          isDirty: true,
        },
      },
    }));
  },

  getDraft: (formId) => {
    return get().drafts[formId] || null;
  },

  clearDraft: (formId) => {
    set((state) => {
      const { [formId]: removed, ...rest } = state.drafts;
      return { drafts: rest };
    });
  },

  getAllDrafts: () => {
    return get().drafts;
  },

  getDraftCount: () => {
    return Object.keys(get().drafts).length;
  },
}));
